import { Layer, Logger } from 'effect'

import { BrowserCookieStoreLayer } from '@viziertronic/browser-cookie-store'
import { PublicConfigProviderLayer } from '@viziertronic/config/next-config-provider'
import { BrowserTracingLayer } from '@viziertronic/observability/open-telemetry/browser'
import { SentryCrashReporterLayer } from '@viziertronic/sentry-next-crash-reporter'

export const TechnicalBrowserLayer = Layer.empty.pipe(
  Layer.provideMerge(SentryCrashReporterLayer),
  Layer.provideMerge(BrowserTracingLayer),
  Layer.provide(Logger.layer([Logger.consolePretty()])),
  Layer.provideMerge(PublicConfigProviderLayer),
)

export const BrowserLayer = Layer.empty.pipe(
  Layer.provideMerge(TechnicalBrowserLayer),
  Layer.provide(BrowserCookieStoreLayer),
  Layer.provideMerge(PublicConfigProviderLayer),
)

export type BrowserLayer = typeof BrowserLayer
export type BrowserLayerOut = Layer.Success<BrowserLayer>
